export function devError(message: string, ...args: any[]) {
    if (process.env.NODE_ENV !== 'production' && console !== undefined) {
        // eslint-disable-next-line no-console
        console.error(`Dev Error: ${message}`, ...args);
    }
}

export function devWarn(message: string, ...args: any[]) {
    if (process.env.NODE_ENV !== 'production' && console !== undefined) {
        // eslint-disable-next-line no-console
        console.warn(`Dev Warning: ${message}`, ...args);
    }
}
